import { fourRetailConfiguration } from "./configuration/4Retail";
import { adiquimicaConfiguration } from "./configuration/Adiquimica";
import { businessCentralConfiguration } from "./configuration/businessCentral";
import { businessCentralOnPremConfiguration } from "./configuration/businessCentralOnPrem";
import { cegidEkonConfiguration } from "./configuration/cegidEkon";
import { holdedConfiguration } from "./configuration/holded";
import { homeserveConfiguration } from "./configuration/homeserve";
import { matiesAmer } from "./configuration/matiesAmer";
import { netSuiteConfiguration } from "./configuration/netsuite";
import { odooConfiguration } from "./configuration/Odoo";
import { sagardiConfigurations } from "./configuration/sagardi";
import { sage } from "./configuration/sage";
import { sapboneConfiguration } from "./configuration/sapboneConfiguration";
import { voloteaConfiguration } from "./configuration/volotea";

const integration = {
  integrations_connected: `Integrations connected`,
  integration_not_connected: `You don’t have any integration connected yet`,
  erp_connected: `ERP connected`,
  new_integration_button_text: `New Integration`,
  add_integration: `Add integration`,
  data_source_connected: `Data source connected`,
  available_integrations: `Integrations available to connect`,
  ERP: `ERP`,
  data_sources: "Data sources",
  data_sinks: `Data sinks`,
  payment_gateways: `Payment Gateways`,
  disconnected_successfully: `{{erpName}} disconnected successfully`,
  connected_successfully: `{{erpName}} connection request sent`,
  unable_to_connect: `Unable to connect {{erpName}}`,
  last_sync_date: `Last sync date`,
  last_sync: `Last sync`,
  sync_now: `Sync now`,
  there_were_some_issues_encountered_during_the_synchronization_process: `There were some issues encountered during the syncing process`,
  enable_vendor_sync_for_supplier_portal: `Enable vendor sync for supplier portal`,
  enable_supplier_sync_for_supplier_portal: `Enable supplier sync for supplier portal`,
  entities_being_synced: `Entities being synced`,
  enable_po_sync_for_discrepancy: `Enable Purchase Order sync for discrepancies`,
  enable_DN_sync_for_discrepancy: `Enable Delivery Note sync for discrepancies`,
  enable_payment_details_sync: `Enable payment details sync`,
  enable_payment_integration: `Enable payment integration`,
  enable_email_on_total_amount_mismatch: `Enable email on total amount mismatch`,
  add_single_or_multiple_api_keys_by_pressing_enter: `Add single / multiple API keys by pressing 'Enter' after each one.`,
  disconnect_integration: `Disconnect {{integration}}`,
  disconnect_integration_warning: `Are you sure you want to disconnect {{integration}}, once disconnected all configurations will be lost`,
  payment_detail_sync_helper_text: ` Sync payment records from NetSuite to the portal`,
  enable_payment_integration_helper_text: `Allow payments integration into NetSuite from portal`,
  onboarding_required: `Onboarding required`,
  onboarding_complete: `Onboarding complete`,
  configurations_updated_successfully: `Configurations updated successfully`,
  enable_purchase_order_sync: `Enable Purchase order sync`,
  xero_configurations: `Xero Configurations`,
  disable_integration_on_integrated_document: `Prevent re-integration on integrated document`,
  disable_integration_on_integrated_document_helper_text: `If enabled, changes made after integration won't be included in future integrations.`,
  notification_apps: ` Notification Apps`,
  SlackNotificationApp: `Slack`,
  WhatsAppNotificationApp: `WhatsApp`,
  "Connect to your Slack account to get all your notifcations.": `Connect to your Slack account to get all your notifcations.`,
  notification_app_connected: `Notification apps connected`,
  userNotificationApp_not_found: `Notification app not found`,
  cannot_connect_more_than_one_notification_of_same_type: `Cannot connect more than one notification app of the same type`,
  notificationapp_module_is_not_enabled: `Notification App module is not enabled`,
  token_has_expired: `Token has expired, please try connecting again`,
  disconnect_notification: `Disconnect {{notification}} Notification`,
  disconnect_notification_warning: `Are you sure you want to disconnect {{notification}} notification? Once disconnected you will no longer receive notifications.`,
  bank_connections: `Bank Connections`,
  ...holdedConfiguration,
  ...businessCentralConfiguration,
  ...businessCentralOnPremConfiguration,
  ...netSuiteConfiguration,
  ...fourRetailConfiguration,
  ...sage,
  ...matiesAmer,
  ...cegidEkonConfiguration,
  ...sagardiConfigurations,
  ...odooConfiguration,
  ...adiquimicaConfiguration,
  ...voloteaConfiguration,
  ...sapboneConfiguration,
  ...homeserveConfiguration,
};

export default integration;
